<script setup>
import { DatePickerTrigger, useForwardProps } from 'reka-ui';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
});

const forwardedProps = useForwardProps(props);
</script>

<template>
    <DatePickerTrigger v-bind="forwardedProps">
        <slot />
    </DatePickerTrigger>
</template>
